import { defineMessages } from 'react-intl';

export default defineMessages({
    returningToWInsurance: {
        id: 'quoteandbind.common.controllers.PaymentCallbackCtrl.Returning to W-Insurance.com...',
        defaultMessage: 'Returning to W-Insurance.com...',
    }
});